import {subTitle, title, buttons, viewBtn} from './InfoTmpl';
import Common from '../../common/CommonNctv';

export default class Info {
    constructor( _container, _option ){
        this.nameIs = 'class-Info';
        this.container = _container;
        this.option = _option;
        this.com = Common.instance;
        
        this.subTitle = $( subTitle(this.option.list[0]) );
        this.title = $( title(this.option.list[0]) );
        this.btnArea = $( buttons(this.option.list[0]) );
        this.viewBtn = $( viewBtn(this.option.list[0], this.com.ip) );
        
        this.btnArea.append( this.viewBtn );

        this.arr = [this.subTitle, this.title, this.btnArea];
        TweenMax.set(this.arr, {css:{opacity:0, y:90}});

        $(_container).append( this.subTitle, this.title, this.btnArea );
        TweenMax.staggerTo(this.arr, 5, {css:{opacity:1, y:0}, ease:Expo.easeOut}, 0.4);
    }

    addEvents(){
    }

    update(_data){
        TweenMax.staggerTo(this.arr, 0.5, {css:{opacity:0}, ease:Expo.easeOut}, 0.2, () => this.showIn(_data));
    }

    showIn(_data){
        this.subTitle.html(_data.desc);
        this.title.html(_data.title);
        this.viewBtn.attr({'href': `/view?tv=${this.com.ip}&id=${_data.id}&from=popular`})

        TweenMax.set(this.arr, {css:{opacity:0, y:90}});
        TweenMax.staggerTo(this.arr, 5, {css:{opacity:1, y:0}, ease:Expo.easeOut}, 0.4);
    }

} // end of class